var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgTogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_24145)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H-7.46484V45H60V0Z",
    fill: "#FFE300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 18.29H-7.46484V27.334H60V18.29ZM60 0.0175781H-7.46484V9.06152H60V0.0175781Z",
    fill: "#118600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0.0263672H33.0615V27.3252H60V0.0263672Z",
    fill: "#D80000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1875 11.2852C48.1875 11.2148 46.5264 6.62695 46.5264 6.62695L45.0322 11.2148C45.0322 11.2148 39.9873 11.3643 39.9873 11.2852C39.9873 11.2061 43.9688 14.2998 43.9688 14.2998C43.9688 14.2998 42.0879 19.5732 42.167 19.415C42.2373 19.2656 46.5264 16.251 46.5264 16.251C46.5264 16.251 50.8945 19.2656 50.8154 19.2656C50.7451 19.2656 49.1631 14.2998 49.1631 14.2998L53.0742 11.3643L48.1875 11.2852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 35.9648H-7.46484V45H60V35.9648Z",
    fill: "#118600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_24145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgTogo);
export default __webpack_public_path__ + "static/media/tg Togo.cd0b32f6e057525995aa98326e32a4c0.svg";
export { ForwardRef as ReactComponent };